import * as Yup from 'yup';
import cn from 'classnames';
import {Formik, Form} from 'formik';
import {useLocation, useNavigate} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';

import {times_hours} from '../../../../post/utility/__data';
import {IDropBottomSheet} from '../../../advertisementRegisteration/types';
import CustomHeader from '../../../../../components/mazraeKit/headers/homeHeader';
import DropBottomSheet from '../../../advertisementRegisteration/pages/optionalInfo/objectComponents/dropBottomsheet';
import OptionalSimpleInput from '../../../advertisementRegisteration/pages/optionalInfo/objectComponents/optionalSimpleInput';
import SimpleCounter from '../../../advertisementRegisteration/pages/optionalInfo/objectComponents/simpleCounter';
import {addOptionalRegisterStoreFormData} from '../../../../../store/redux/registerStore';
import {labValueOptionalForm} from '../../contants';
import {RootState} from '../../../../../store/redux';
import FormikSelect from '../../../../../components/formikFileds/select';

function OptionalInfoLab() {
  const AddSchema = Yup.object().shape({});
  const navigate = useNavigate();
  const locationState = useLocation();
  const dispatch = useDispatch();
  const state = useSelector((state: RootState) => state.registerStore);

  const compoentns: Record<string, IDropBottomSheet> = {
    dropBottomSheet: {
      component: ({
        data,
        onChange,
        placeholder,
        name,
        value,
        generalTitle,
        generalDesc,
        subDesc,
        disabled,
      }) => (
        <DropBottomSheet
          name={name}
          placeholder={placeholder}
          onChange={e => onChange(name, e)}
          value={
            typeof value === 'object'
              ? (value?.title as string)
              : (value as string)
          }
          data={data || []}
          generalTitle={generalTitle}
          generalDesc={generalDesc}
          subDesc={subDesc}
          disabled={disabled}
        />
      ),
    },
    optionalSimpleInput: {
      component: ({onChange, label, name, placeholder}) => (
        <>
          <span className='font-medium'>تخصص (اختیاری)</span>
          <OptionalSimpleInput
            name={name}
            label={label}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              onChange(name, e.target.value);
            }}
            placeholder={placeholder}
          />
        </>
      ),
    },
    simpleCounter: {
      component: ({onChange, name}) => (
        <SimpleCounter name={name} onChange={e => onChange(name, e)} />
      ),
    },
  };
  const choosenForm = [
    {
      name: 'result_to_day',
      componentType: 'simpleCounter',
    },
    {
      name: 'speciality',
      placeholder: 'تخصص آزمایشگاه خود را وارد کنید',
      // schema: {},
      label: '',
      componentType: 'optionalSimpleInput',
    },
  ];

  return (
    <div className="flex flex-col h-full text-md text-gray-900">
      <CustomHeader
        preIcon=""
        title="سایر مشخصات(اختیاری)"
        postComponent={() => (
          <i
            className="icon-nameClose-remove"
            onClick={() => {
              if (locationState?.state?.lab_guid) {
                navigate(
                  `/edit-register-store/lab/${locationState.state.lab_guid}`,
                  {
                    state: {
                      tab: 4,
                    },
                  },
                );
              } else {
                navigate(`/register-lab`, {
                  state: {
                    tab: 4,
                  },
                });
              }
            }}
          />
        )}
      />
      <Formik
        initialValues={labValueOptionalForm(state?.optionalRegisterFormData)}
        // initialValues={initialValues}
        validationSchema={AddSchema}
        onSubmit={values => {
          dispatch(addOptionalRegisterStoreFormData(JSON.stringify(values)));
          if (locationState?.state?.lab_guid) {
            navigate(
              `/edit-register-store/lab/${locationState.state.lab_guid}`,
              {
                state: {
                  tab: 4,
                },
              },
            );
          } else {
            navigate(`/register-lab`, {
              state: {
                tab: 4,
              },
            });
          }
        }}
      >
        {({setFieldValue, values, errors, isValid, touched}) => {
          return (
            <Form className="flex flex-col px-3 pb-3 h-full">
              <div className={cn('flex flex-col w-full gap-3 mt-3 h-full')}>
                <div className="flex flex-col gap-4 text-gray-900 text-md">
                  <p className="font-medium mb-0">ساعت کار</p>
                  <span>
                    ساعت کار آزمایشگاه را جهت تماس و مراجعه حضوری مشخص کنید
                  </span>
                  <FormikSelect
                    name="from_hour"
                    label="از ساعت"
                    Options={times_hours}
                  />
                  <FormikSelect
                    name="to_hour"
                    label="تا ساعت"
                    Options={times_hours}
                  />
                </div>
                {choosenForm?.map(item => {
                  return compoentns[item.componentType].component({
                    // data: item.data,
                    onChange: setFieldValue,
                    //@ts-ignore
                    value: values[item?.name],
                    placeholder: item.placeholder,
                    name: item.name,
                    label: item.label,
                    // generalTitle: item.generalTitle,
                    // generalDesc: item.generalDesc,
                    errors: errors,
                    touched: touched,
                  });
                })}
              </div>
              <button
                type="submit"
                className="bg-farm-shop-500 h-12 rounded w-full text-white mt-6"
                onClick={() => {
                  dispatch(
                    addOptionalRegisterStoreFormData(JSON.stringify(values)),
                  );
                }}
              >
                ذخیره مشخصات
              </button>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
}

export default OptionalInfoLab;
